// FE companion to backend PR #504 (audit E — fail-closed PVC delete).
//
// The user "Remove gateway" is the ONLY action allowed to delete a session's PVC (its WhatsApp
// auth store). The backend deletes the PVC only when the DELETE carries an explicit `deletePvc`
// flag AND an owner user JWT AND the doc is present — read as a QUERY param
// (`params.query.deletePvc`, k8s-engine-manager.class.ts remove()). A bare DELETE from any other
// caller (a pod teardown, a script, an old image) never deletes the PVC.
//
// So the FE "Remove gateway" DELETE must include `?deletePvc=true`.
export function deleteK8sEngineUrl(sessionId: string): string {
  return `k8s-engine-manager/${sessionId}?deletePvc=true`;
}
